export default __webpack_public_path__ + "dist/media/Recall-bg.d553d914.svg";